import styled from 'styled-components';

import { Text } from '../../components';
import { COLORS, MOBILE, SPACE, WEBSITE_HUB } from '../../theme/tokens';

/** Holds a tile glyph's gradient definition: takes no room and paints nothing itself. */
export const InkDefs = styled.svg`
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
`;

/** One stop of a glyph's sweep, in its area's ink (a token, see HUB_AREA). */
export const InkStop = styled.stop<{ $color: string }>`
  stop-color: ${(p) => p.$color};
`;

/** The hub's header: the page title over its one-line subtitle. */
export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
  margin: 0 0 ${SPACE[20]};

  ${MOBILE} {
    margin-bottom: ${SPACE[16]};
  }
`;

/** The hub's title, at the app's section-title size (the shared SectionTitle's 20px). */
export const HubTitle = styled(Text)`
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.2;
  color: ${COLORS.heading};
`;

export const HubSubtitle = styled(Text)`
  margin: 0;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.45;
  color: ${COLORS.textMuted};
`;
